export const expandableListItems = [
  {
    icon: 'pie-chart',
    title: 'Amet 1',
    description: 'This is Item 1 description',
    properties: { hosts: 3, clusters: 1, nodes: 7, images: 4 },
    expandedContentText:
      'Item 1: Lorem Ipsum is simply dummy text of the printing and typesetting industry'
  },
  {
    icon: 'pie-chart',
    title: 'Amet 2',
    description: 'This is Item 2 description',
    properties: { hosts: 2, clusters: 1, nodes: 11, images: 8 },
    expandedContentText:
      'Item 2: Lorem Ipsum is simply dummy text of the printing and typesetting industry'
  },
  {
    icon: 'sitemap',
    title: 'Amet 3',
    description: 'This is Item 3 description',
    properties: { hosts: 4, clusters: 2, nodes: 9, images: 8 },
    expandedContentText:
      'Item 3: Lorem Ipsum is simply dummy text of the printing and typesetting industry'
  },
  {
    icon: 'tag',
    title: 'Amet 4',
    description: 'This is Item 4 description',
    properties: { hosts: 0, clusters: 1, nodes: 9, images: 7 },
    expandedContentText:
      'Item 4: Lorem Ipsum is simply dummy text of the printing and typesetting industry'
  },
  {
    icon: 'tag',
    title: 'Amet 5',
    description: 'This is Item 5 description',
    properties: { hosts: 10, clusters: 11, nodes: 19, images: 17 },
    expandedContentText:
      'Item 5: Lorem Ipsum is simply dummy text of the printing and typesetting industry'
  }
];



// WEBPACK FOOTER //
// ./src/pages/mocks/amet-list-data.js